import { soundManager, SoundType } from '../../domain/sound/SoundManager'
import { Button } from '../../UI'

interface RulesProps {
  x: number
  y: number
  width: number
  height: number
  enabled: boolean
  onPress: () => void
}

export const RulesButtonV2 = (props: RulesProps) => {
  return (
    <Button
      name="rules"
      defaultView="info_on_normal_v2"
      hoverView="info_on_hover_v2"
      pressedView="info_on_click_v2"
      disabledView="info_on_unable_v2"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      enabled={props.enabled}
      onPressing={() => {
        soundManager.play(SoundType.buttonConfirm)
      }}
      onPress={props.onPress}
    />
  )
}
